import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ViewComponent } from './view/view.component';
import { ThemingService } from 'src/providers/theming.service';
import { HttpService } from './wrappers/Http';
import { HttpClientModule } from '@angular/common/http';
import { WebsocketService } from 'src/providers/WebsocketService';

@NgModule({
  declarations: [
    AppComponent,
    ViewComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule
  ],
  providers: [ThemingService, HttpService, WebsocketService],
  bootstrap: [AppComponent]
})
export class AppModule { }
